import Vue from 'vue'
import {
    Dialog,
    Toast,
    List,
    Lazyload,
    Rate,
    ImagePreview,
    Icon,
    Button,
    Row,
    Col,
    Loading,
    Swipe,
    SwipeItem,
    Field,
    CellGroup,
    Cell,
    Search,
    Popup,
    Collapse,
    CollapseItem,
    PullRefresh,
    Tab,
    Tabs,
    Actionsheet,
    Uploader
} from 'vant'

Vue.prototype.$toast = Toast;

const components = [
    Dialog,
    Toast,
    List,
    Lazyload,
    Rate,
    ImagePreview,
    Icon,
    Button,
    Row,
    Col,
    Loading,
    Swipe,
    SwipeItem,
    Field,
    CellGroup,
    Cell,
    Search,
    Popup,
    Collapse,
    CollapseItem,
    PullRefresh,
    Tab,
    Tabs,
    Actionsheet,
    Uploader

];

components.map(component => {
  Vue.use(component);
})


// WEBPACK FOOTER //
// ./src/common/js/vanCom.js